import React from 'react';
import style from 'assets/jss/material-dashboard-pro-react/components/customTableComponentStyle';
import { TableContainer, Table, TableBody, TableHead, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';

// @ts-ignore
const useStyle = makeStyles(style);

interface ITableComponent {
	tableColumns: JSX.Element[];
	tableRows?: JSX.Element[];
	customClassName?: Object;
}

const CustomTableComponent = (props: ITableComponent) => {
	const { tableColumns, tableRows } = props;
	const classes = useStyle();
	return (
		<div
			className={classNames({
				// @ts-ignore
				[props.customClassName]: true,
				[classes.fbbTableWrapper]: true,
			})}
		>
			<TableContainer>
				<Table>
					<TableHead className={classes.tableHead}>
						<TableRow>
							{tableColumns.map((cell) => {
								return cell;
							})}
						</TableRow>
					</TableHead>
					<TableBody>
						{tableRows?.map((row) => {
							return row;
						})}
					</TableBody>
				</Table>
			</TableContainer>
		</div>
	);
};

export default CustomTableComponent;
